import React from "react";
import { WizardOption } from "../wizardOptions";
import styles from "./WizardQuestion.module.css";

interface WizardQuestionProps {
  number: number;
  question: string;
  helper?: string;
  placeholder: string;
  options: WizardOption[];
  value: string;
  onChange: (next: string) => void;
}

export default function WizardQuestion({
  number,
  question,
  helper,
  placeholder,
  options,
  value,
  onChange,
}: WizardQuestionProps) {
  const answered = value.length > 0;

  return (
    <div className={`${styles.card} ${answered ? styles.answered : ""}`}>
      <div className={styles.headerRow}>
        <div className={`${styles.badge} ${answered ? styles.badgeDone : ""}`}>
          {answered ? (
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          ) : (
            <span>{number}</span>
          )}
        </div>
        <div className={styles.textCol}>
          <p className={styles.question}>{question}</p>
          {helper && <p className={styles.helper}>{helper}</p>}
        </div>
      </div>

      <div className={styles.selectWrap}>
        <select
          className={`${styles.select} ${answered ? styles.selectAnswered : ""}`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <span className={styles.chevron}>▾</span>
      </div>
    </div>
  );
}
